<template>
  <div class="row justify-content-md-center mt-4 blockAudienceStar dataTable">
    <div class="col-md-12">
      <h1 class="mb-5 mt-5 titlePage font-weight-normal text-capitalize" style="color: #22252b">
        {{ $t('audience.segmentList.header1') }}
      </h1>
      <CAlert :color="this.$route.params.status" closeButton v-if="this.$route.params.message" :show.sync="currentAlertCounter">
        <center>
          <strong>{{ this.$route.params.message }}</strong>
        </center>
        <CProgress :max="10" :value="currentAlertCounter" height="3px" :color="this.$route.params.status" animate />
      </CAlert>
      <CCardHeader class="dataTable__header d-flex justify-content-between px-0 pb-3" v-if="hasAudience && segments.length > 0">
        <div class="dataTable__search">
          <CInput
            type="search"
            :placeholder="$t('campaign.campaignList.placeholder-search')"
            addInputClasses="pl-5"
            class="iconSearchPlaceholder pb-0"
            v-model="search"
          >
          </CInput>
        </div>
        <div class="dataTable__buttonLink">
          <button
            class="btn btn-primary px-5 py-3 font-weight-bold"
            tag="button"
            @click="$router.push({ name: 'segment-create' })"
            :class="hasAudience ? '' : 'disabled'"
          >
            {{ $t('audience.segmentList.button.createSegment') }}
          </button>
        </div>
      </CCardHeader>
      <hr class="hrTable mt-5" />
      <template v-if="segments.length > 0">
        <HeaderActions
          :show="{
            checkItems: true,
            manage: false,
            orderByDate: {
              type: 'created',
              show: true,
            },
            delete: true
          }"
          :itemsListSelected="Boolean(verifyIfHasSelected())"
          typeName="Segment"
          @checkAll="checkAll"
          @confirm="deleteList"
          @deleteAll="deleteList"
          @sortByDate="sortByDate"
        />

        <div class="" style="margin-bottom: 200px">
          <div class="loading" v-if="loading">
            <CSpinner class="my-3" color="primary" />
          </div>
          <table class="table" style="font-size: 0.94rem; color: #a1a8b3" v-if="!loading">
            <tbody>
              <tr v-for="seg in filteredItems" :key="seg._id" :class="{ trChecked: verifyIfIsChecked(seg._id) }">
                <td style="width: 5%">
                  <label class="containerCheck">
                    <input type="checkbox" class :checked="verifyIfIsChecked(seg._id)" @change="changeCheck(seg._id)" />
                    <span class="checkmark"></span>
                  </label>
                </td>
                <td style="width: 55%" @click="goToDatail(seg._id, seg.segmentId)">
                  {{ seg.name }}
                </td>
                <td style="width: 20%" @click="goToDatail(seg._id, seg.segmentId)">{{ seg.totalContacts }} contacts</td>
                <td style="width: 20%" @click="goToDatail(seg._id, seg.segmentId)">Created at {{ opt(seg._MetaData.createdDateTime) }}</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-between">
            <div class="boxPag" @click="previousPage()" :class="{ 'box-pag-bg-disable': isBoxPagDisable('previous') }">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </div>
            <div v-if="pagination.totalPages > 1" class="paginationText">{{ pagination.currentPage }} of {{ pagination.totalPages }}</div>
            <div class="boxPag" @click="nextPage()" :class="{ 'box-pag-bg-disable': isBoxPagDisable('forward') }">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </div>
          </div>
          <!-- <CPagination
            v-show="pagination.totalPages > 0"
            align="center"
            :pages="pagination.totalPages"
            :active-page.sync="pagination.currentPage"
            class="dataTable__newPagination mt-3"
          >
            <template slot="previous-button">
              <span class="newPagination__button p-2 btnPagination">
                {{ $t('audience.audienceList.text.prev') }}
              </span>
            </template>
            <template slot="next-button">
              <span class="newPagination__button p-2 btnPagination">
                {{ $t('audience.audienceList.text.next') }}
              </span>
            </template>
          </CPagination> -->
        </div>
      </template>
      <div v-if="segments.length == 0 && !hasAudience">
        <EmptyList
          :loading="loadingGetList"
          :linkText="$t('audience.audienceList.button.import-contacts')"
          :linkTo="{ name: 'import-contacts' }"
          :title="$t('audience.audienceList.text.noAudience')"
          :subTitle="$t('audience.audienceList.text.importOrCreate')"
        />
      </div>
      <div v-if="segments.length == 0 && hasAudience">
        <EmptyList
          :loading="loadingGetList"
          :linkText="$t('audience.segmentList.button.createSegment')"
          :linkTo="{ name: 'segment-create' }"
          :title="$t('audience.segmentList.text.noSegments')"
          :subTitle="$t('audience.segmentList.text.createSegments')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { dateTimeFormatString } from '@/utils/dateUtil'
import services from '@/services.js'
import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import EmptyList from '@/components/EmptyList'
export default {
  name: 'SegmentsList',
  components: {
    HeaderActions,
    MenssageAlert,
    EmptyList,
  },
  props: {},
  data() {
    return {
      loadingGetList: false,
      page: 0,
      count: 10,
      sortField: undefined,
      sort: undefined,
      segments: [],
      elementChecked: [],
      allIsChecked: 0,
      openModal: false,
      search: '',
      loading: true,
      currentAlertCounter: 5,
      pagination: {},
    }
  },
  created() {
    this.loadingGetList = true
  },
  mounted() {
    this.getClientSegmentsList()
  },
  methods: {
    formatDate(date) {
      var startUTC = DateTime.fromISO(date, { zone: 'utc' })
      let end = DateTime.fromJSDate(new Date())
      // let start = DateTime.fromJSDate(date);
      let result = end.diff(startUTC, ['months', 'days']).shiftTo('years', 'months', 'weeks', 'days', 'hours', 'minutes').values
      if (result.years > 0) return result.years + (result.years === 1 ? ' year ' : ' years ') + 'ago'

      if (result.months > 0) return result.months + (result.months === 1 ? ' month ' : ' months ') + 'ago'

      if (result.weeks > 0) return result.weeks + (result.weeks === 1 ? ' year ' : ' years ') + 'ago'

      if (result.days > 0) return result.days + (result.days === 1 ? ' day ' : ' days ') + 'ago'

      if (result.hours > 0) return result.hours + (result.hours === 1 ? ' hour ' : ' hours ') + 'ago'

      if (result.minutes > 0) {
        if (result.minutes < 1) {
          return 'few seconds ago'
        }
        result.minutes = Math.floor(result.minutes)
        return result.minutes + (result.minutes === 1 ? ' minute ' : ' minutes ') + 'ago'
      }
    },

    opt(data) {
      const dateCurrent = data
      return dateTimeFormatString(dateCurrent)
    },

    getClientSegmentsList: function () {
      this.loading = true
      this.elementChecked = []
      services
        .getClientSegmentsList(this.organizationId, this.page, this.count, this.sortField, this.sort)
        .then((response) => {
          this.segments = response.data.data.segments
          this.pagination = response.data.data.pagination
          // Resolve problema do MongoDB ser zero-based para a paginação e API não
          this.pagination.currentPage = response.data.data.pagination.currentPage + 1

          for (let i = 0; i < this.segments.length; i++) {
            this.elementChecked.push({ _id: this.segments[i]._id, checked: 0 })
          }
        })
        .catch((error) => {
          // TODO FALTOU ADD ERROR AO CATCH
        })
        .finally(() => {
          this.loading = false
          this.loadingGetList = false
        })
    },

    verifyCount(value) {
      if (value < 10) {
        return value
      } else if (value > 9) {
        return 10
      }
    },

    verifyIfIsChecked(id) {
      let seg = this.elementChecked
      for (let i = 0; i < seg.length; i++) {
        if (seg[i]._id === id) {
          return seg[i].checked
        }
      }
    },

    changeCheck(id) {
      let seg = this.elementChecked
      for (let i = 0; i < seg.length; i++) {
        if (seg[i]._id === id && seg[i].checked === 0) {
          seg[i].checked = 1
        } else if (seg[i]._id === id && seg[i].checked === 1) {
          seg[i].checked = 0
        }
      }
    },

    checkAll() {
      let segm = this.elementChecked
      for (let i = 0; i < segm.length; i++) {
        if (this.allIsChecked === 0) {
          segm[i].checked = 1
        } else if (this.allIsChecked === 1) {
          segm[i].checked = 0
        }
      }

      if (this.allIsChecked === 0) {
        this.allIsChecked = 1
      } else if (this.allIsChecked === 1) {
        this.allIsChecked = 0
      }
    },

    isBoxPagDisable(direction) {
      if (direction == 'forward') {
        return this.pagination.nextPage == this.pagination.totalPages
      }
      
      if (direction == 'previous') {
        return this.page === 0
      }
    },

    verifyIfHasSelected() {
      let seg = this.elementChecked
      let check = 0
      for (let i = 0; i < seg.length; i++) {
        if (seg[i].checked === 1) {
          check = 1
        }
      }
      return check
    },

    deleteList() {
      let segmentsList = this.prepareListToDelete()
      this.openModal = false
      this.loading = true

      services
        .deleteClientSegment(this.organizationId, { id: segmentsList })
        .then((response) => {
          const isEntirePageDeleted = this.pagination.currentCount == segmentsList.length
          const isNotFirstPage = this.page > 0
          if (isEntirePageDeleted && isNotFirstPage) {
            this.page = this.page - 1
          }
          this.getClientSegmentsList()
        })
        .catch((error) => {
          this.getClientSegmentsList()
        })
    },

    prepareListToDelete() {
      let checkedList = []
      for (let i = 0; i < this.elementChecked.length; i++) {
        if (this.elementChecked[i].checked === 1) {
          checkedList.push(this.elementChecked[i]._id)
        }
      }

      return checkedList
    },

    confirmDeleteList() {
      this.openModal = false
    },

    nextPage() {
      this.page = this.page + 1
      this.getClientSegmentsList()
    },

    previousPage() {
      if (this.page === 0) {
        return
      }
      this.page = this.page - 1
      this.getClientSegmentsList()
    },

    sortByDate(sortDirection) {
      this.sortField = 'createdDateTime'
      this.sort = sortDirection ? 'ascending' : 'descending'
      
      this.getClientSegmentsList()
    },

    goToDatail(id, segmentId) {
      this.$router.push({ name: 'segments-details', params: { id: id, segmentIdGuid: segmentId } })
    },
  },

  computed: {
    filteredItems() {
      return this.segments.filter((item) => {
        return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    },

    organizationId() {
      return this.$store.state.auth.organizationId
    },

    hasAudience() {
      return this.$store.state.audience.hasAudience
    },
  },
}
</script>

<style lang="scss" scoped>
.modalCancel {
  position: relative;
  margin-left: 0px;
  margin-top: 30px;
  width: 360px;
  z-index: 1;
  &__body {
    background: #fff;
    position: absolute;
    width: 100%;
    max-width: 360px;
    border: 2px solid #edeff1;
  }
}

.btn-audience-create {
  color: white !important;
  text-decoration: none !important;
  float: right;
  padding: 1rem 1.5rem;
  font-weight: bold;
}

.hide {
  display: none;
}

.paginationText {
  color: #a1a8b3;
  line-height: 3;
}

.trash-list {
  position: absolute;
  left: 60px;
  top: 3px;
  font-size: 15px;
  color: #a1a8b3;
  cursor: pointer;
}

.boxPag {
  background-color: #fff;
  width: 50px;
  height: 45px;
  line-height: 2.9;
  text-align: center;
  color: #d1d4da;
  cursor: pointer;
}

.boxPag:hover {
  background-color: #edeff1;
}

.box-pag-bg-disable {
  background-color: #edeff1 !important;
  pointer-events: none;
}

p {
  line-height: 1rem;
}

.form-search {
  font-size: 1rem;
  width: 500px;
  height: 50px;
  padding-left: 40px;
}

.divSearch {
  position: relative;
}

.serachBox {
  color: #9da5ab;
  position: absolute;
  top: 15px;
  left: 10px;
  font-size: 20px;
}

.hrTable {
  border-top: 1px solid #d1d4da;
  margin-bottom: 0;
}

.textDateCreated {
  color: #a1a8b3;
  font-size: 14px;
}

.iconDateCreated {
  color: #a1a8b3;
  font-size: 15px;
  margin-left: 7px;
  margin-right: 8px;
  cursor: pointer;
}

.table th,
.table td {
  padding: 0.85rem;
  border-top: none;
}

.table th,
.table tr:hover {
  background-color: #fff;
  cursor: pointer;
  color: #656971;
  -webkit-box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  -moz-box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  box-shadow: -1px -1px 16px -8px rgba(94, 94, 94, 0.73) !important;
  border: none !important;
}

.table {
  background-color: #fff;
  overflow-x: auto;
  white-space: nowrap;
}

.table tr {
  border-top: 2px solid #edeff1;
}

.trChecked {
  background-color: #edeff1;
}

.trChecked:hover {
  background-color: #edeff1 !important;
}

.containerCheck {
  display: block;
  position: relative;
  margin-bottom: 12px;
  margin-left: 3px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.containerCheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
}

/* On mouse-over, add a grey background color */
.containerCheck:hover input ~ .checkmark {
  background-color: #fff;
}

/* When the checkbox is checked, add a blue background */
.containerCheck input:checked ~ .checkmark {
  background-color: #403266;
  border: 1px solid #403266;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.containerCheck input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.containerCheck .checkmark:after {
  left: 6px;
  top: 4px;
  width: 5px;
  height: 8px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.CSpinner {
  border: none;
  width: 83px;
  height: 83px;
  background: url(/img/icons/spinner.gif);
}

.loading {
  width: 100%;
  background-color: white;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>
